import React from "react";
import TextField from "@material-ui/core/TextField";
import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import { Box } from "@material-ui/core";
import { AuhMethods } from "../../../../services/auth";
import ContentLoader from "../../ContentLoader";
import { alpha, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { CurrentAuthMethod } from "../../../constants/AppConstants";
import { NavLink } from "react-router-dom";
import AuthWrapper from "./AuthWrapper";
import { useForm } from "react-hook-form";

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "50%",
      order: 2
    }
  },
  authContent: {
    padding: 30,
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: props => (props.variant === "default" ? "50%" : "100%"),
      order: 1
    },
    [theme.breakpoints.up("xl")]: {
      padding: 50
    }
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary
  },
  textFieldRoot: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: alpha(theme.palette.common.dark, 0.12)
    }
  },
  formcontrolLabelRoot: {
    "& .MuiFormControlLabel-label": {
      [theme.breakpoints.down("xs")]: {
        fontSize: 12
      }
    }
  }
}));
//variant = 'default', 'standard'
const SignIn = ({
  method = CurrentAuthMethod,
  variant = "default",
  wrapperVariant = "default"
}) => {
  const dispatch = useDispatch();
  const classes = useStyles({ variant });
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({mode:"onChange"});
  const handleSubmitForm = dataForm => {
    dispatch(
      AuhMethods[method].onLogin({
        phone: dataForm.phone,
        password: dataForm.password
      })
    );
  };

  return (
    <AuthWrapper variant={wrapperVariant}>
      <Box className={classes.authContent}>
        <Typography component="div" variant="h1" className={classes.titleRoot}>
          Đăng nhập
        </Typography>
        <form onSubmit={handleSubmit(handleSubmitForm)}>
          <Box mb={2}>
            <TextField
              {...register("phone", {
                required: true
              })}
              label="Số điện thoại"
              fullWidth
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
            {errors.phone?.type === "required" && (
              <span style={{ color: "#cc3300" }}>
                Vui lòng nhập số điện thoại
              </span>
            )}
          </Box>
          <Box mb={2}>
            <TextField
              {...register("password", {
                required: true
              })}
              type="password"
              label="Mật khẩu"
              fullWidth
              margin="normal"
              variant="outlined"
              className={classes.textFieldRoot}
            />
            {errors.password?.type === "required" && (
              <span style={{ color: "#cc3300" }}>
                Vui lòng nhập số mật khẩu
              </span>
            )}
          </Box>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Button type="submit" variant="contained" color="primary">
              Đăng nhập
            </Button>

            <Box component="p" fontSize={{ xs: 10, sm: 14 }}>
              <NavLink to="/signup">Tạo tài khoản mới</NavLink>
            </Box>
          </Box>
        </form>

        {dispatch(AuhMethods[method].getSocialMediaIcons())}

        <ContentLoader />
      </Box>
    </AuthWrapper>
  );
};

export default SignIn;
